var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 142,
    viewBox: "0 0 169 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.243 125.89C169.041 126.694 169.053 127.945 168.271 128.685L155.528 140.742C154.746 141.481 153.466 141.43 152.668 140.626C151.871 139.823 151.858 138.572 152.64 137.832L163.968 127.115L152.419 115.476C151.621 114.673 151.609 113.422 152.391 112.682C153.173 111.942 154.453 111.994 155.25 112.797L168.243 125.89ZM4.00482 0.84019C7.4753 26.6217 16.444 56.3799 40.2548 80.3329C64.0327 104.253 102.911 122.681 166.808 125.254L166.847 129.206C102.214 126.603 62.1789 107.916 37.4256 83.0148C12.7051 58.1467 3.52488 27.3776 -0.00442471 1.15911L4.00482 0.84019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigArrow);
export default __webpack_public_path__ + "static/media/big_arrow.6cc1ff3ebc5fcfbc9ac795af8100ebf0.svg";
export { ForwardRef as ReactComponent };